import './BottomNav.css';

type Tab = 'home' | 'explore';

interface Props {
  tab: Tab;
  onChange: (tab: Tab) => void;
  favoritesCount: number;
}

export function BottomNav({ tab, onChange, favoritesCount }: Props) {
  return (
    <nav className="bottom-nav">
      <button
        className={`nav-tab ${tab === 'home' ? 'active' : ''}`}
        onClick={() => onChange('home')}
      >
        <span className="nav-icon">🏠</span>
        <span className="nav-label">Home</span>
        {favoritesCount > 0 && tab !== 'home' && (
          <span className="nav-badge">{favoritesCount}</span>
        )}
      </button>
      <button
        className={`nav-tab ${tab === 'explore' ? 'active' : ''}`}
        onClick={() => onChange('explore')}
      >
        <span className="nav-icon">🔍</span>
        <span className="nav-label">Explore</span>
      </button>
    </nav>
  );
}
